import gql from "graphql-tag"

const TransactionsQuery = gql`query TransactionsQuery($cursor: String,$first:Int!,$ids: [ID], $driverId:ID,$chargeTypeIds:[ID],$groupTypeIds:[ID],$includeDeleted:Boolean,$minAmount:Float,$maxAmount:Float,$eventDatetimeGte:Date,$eventDatetimeLte:Date, $dateAddedGte: Date, $dateAddedLte: Date,$notes:String, $orderBy:[String], $includeUpdates:Boolean, $loadDynamicValues: Boolean!, $paymentPlanCompatible: Boolean, $ignoreUpdatesExceptChargeIds: [ID]) {
    transactions: allTransactions(first:$first,after: $cursor,driverId:$driverId, ids: $ids, chargeTypeIds:$chargeTypeIds,groupTypeIds:$groupTypeIds,includeDeleted:$includeDeleted,minAmount:$minAmount,maxAmount:$maxAmount, eventDatetimeGte: $eventDatetimeGte, eventDatetimeLte: $eventDatetimeLte, dateAddedGte: $dateAddedGte, dateAddedLte: $dateAddedLte, notes:$notes, orderBy: $orderBy, includeUpdates:$includeUpdates, paymentPlanCompatible:$paymentPlanCompatible, ignoreUpdatesExceptChargeIds:$ignoreUpdatesExceptChargeIds){
        edges{
            node{
                id
                pk
                dateAdded
                dueDate
                amount
                dynamicAmount @include(if: $loadDynamicValues)
                dynamicBalance @include(if: $loadDynamicValues)
                eventDatetime
                notes
                balance
                isDeleted
                isAssociatedWithPlan
                updateFor {
                    id
                    updateForPK: pk
                }
                chargeType{
                    id
                    name
                    paymentPlanCompatible
                }
                groupType{
                    id
                    name
                }
                agreement{
                    id
                    startDate
                    endDate
                    car {
                        id
                        carPK: pk
                    } 
                }
                status
                createdBy{
                    id
                    username
                    firstName
                    lastName
                }
                branch{
                    id
                    name
                }
            }
        }
        pageInfo{
            endCursor
            hasNextPage
        }
    } 
}`

const AllChargeTypes = gql`query AllChargeTypes{
    allChargeTypes(isActive:true,orderBy:["name"]){
        edges {
            node {
            id
            name
            category
            }
        }
        }
}`

const AllGroupTypes = gql`query AllGroupTypes{
    allGroupTypes(isActive:true,orderBy:["name"]){
        edges {
        node {
            id
            name
        }
        }
    }
}`

const DriverBillingDayQuery = gql`query Driver($driverId:ID!){
    driver(id:$driverId){
        id
        chargeDayofweek
    }
}`

export { TransactionsQuery, AllChargeTypes, AllGroupTypes, DriverBillingDayQuery }
